export default "/institutions/banco-do-brasil.svg";